import { ApolloClient, InMemoryCache, HttpLink, from } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import { 
  myStageGraphQlEndpoint, 
  mystageServiceIdHeaderName, 
} from '@/utils/constants';
import { 
  getMyStageRefreshToken,
  getServiceId 
} from '@/modules/myStageGraphQL/AuthCookieManager';

const authLink = setContext((_, { headers }) => {
  const token = getMyStageRefreshToken();
  const serviceId = getServiceId();

  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : '',
      [mystageServiceIdHeaderName]: serviceId || ''
    },
  };
});

const httpLink = new HttpLink({
  uri: myStageGraphQlEndpoint,
  credentials: 'omit',              
});

export default new ApolloClient({
  link: from([authLink, httpLink]),
  cache: new InMemoryCache(),            
  defaultOptions: {
    mutate: {
      fetchPolicy: 'no-cache',
    },
  },
});
